// // src/pages/Users.js
// import React, { useState } from "react";
// import { CSSTransition, TransitionGroup } from "react-transition-group"; // 👈 added
// import "../styles/Users.css";

// const dummyUsers = [
//   {
//     id: 1,
//     name: "John Doe",
//     email: "john@example.com",
//     role: "User",
//     status: "Active",
//     signupDate: "2025-09-01",
//     dispatches: { completed: 5, pending: 2, failed: 1 },
//   },
//   {
//     id: 2,
//     name: "Jane Smith",
//     email: "jane@example.com",
//     role: "Admin",
//     status: "Banned",
//     signupDate: "2025-08-21",
//     dispatches: { completed: 10, pending: 0, failed: 0 },
//   },
// ];

// const Users = () => {
//   const [users, setUsers] = useState(dummyUsers);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [search, setSearch] = useState("");
//   const [filter, setFilter] = useState("All");

//   // Quick Stats
//   const totalUsers = users.length;
//   const activeUsers = users.filter((u) => u.status === "Active").length;
//   const bannedUsers = users.filter((u) => u.status === "Banned").length;


//   const handleBanToggle = (id) => {
//     setUsers((prev) =>
//       prev.map((u) =>
//         u.id === id
//           ? { ...u, status: u.status === "Active" ? "Banned" : "Active" }
//           : u
//       )
//     );
//   };

//   const handleDelete = (id) => {
//     setUsers((prev) => prev.filter((u) => u.id !== id));
//   };

//   const filteredUsers = users.filter((u) => {
//     const matchesSearch =
//       u.name.toLowerCase().includes(search.toLowerCase()) ||
//       u.email.toLowerCase().includes(search.toLowerCase());
//     const matchesFilter = filter === "All" || u.status === filter;
//     return matchesSearch && matchesFilter;
//   });

//   return (
//     <div className="users-section">
//       <div className="users-header">
//         <h2>Manage Users</h2>
//         <p>Monitor, search, and control your user base.</p>
//       </div>

//       {/* Controls */}
// <div className="users-controls">
//   <input
//     type="text"
//     placeholder="🔍 Search users..."
//     value={search}
//     onChange={(e) => setSearch(e.target.value)}
//   />
//   <select
//     value={filter}
//     onChange={(e) => setFilter(e.target.value)} // dropdown controls filter
//   >
//     <option value="All">All</option>
//     <option value="Active">Active</option>
//     <option value="Banned">Banned</option>
//   </select>
// </div>

// {/* Quick Stats */}
// <div className="users-stats">
//   <div
//     className={`stat-card ${filter === "All" ? "active-stat" : ""}`}
//     onClick={() => setFilter("All")} // clicking card updates dropdown too
//   >
//     <h3>{totalUsers}</h3>
//     <p>Total Users</p>
//   </div>
//   <div
//     className={`stat-card ${filter === "Active" ? "active-stat" : ""}`}
//     onClick={() => setFilter("Active")}
//   >
//     <h3>{activeUsers}</h3>
//     <p>Active</p>
//   </div>
//   <div
//     className={`stat-card ${filter === "Banned" ? "active-stat" : ""}`}
//     onClick={() => setFilter("Banned")}
//   >
//     <h3>{bannedUsers}</h3>
//     <p>Banned</p>
//   </div>
// </div>




//       {/* Users Table */}
//       <table className="users-table">
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Email</th>
//             <th>Role</th>
//             <th>Status</th>
//             <th>Signup</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//   <TransitionGroup component={null}>
//     {filteredUsers.map((u) => (
//       <CSSTransition key={u.id} timeout={300} classNames="fade-row">
//         <tr>
//           <td>{u.name}</td>
//           <td>{u.email}</td>
//           <td>
//             <span className={`role-badge ${u.role.toLowerCase()}`}>
//               {u.role}
//             </span>
//           </td>
//           <td>
//             <span className={`status-badge ${u.status.toLowerCase()}`}>
//               {u.status}
//             </span>
//           </td>
//           <td>{u.signupDate}</td>
//           <td>
//             <button className="btn view" onClick={() => setSelectedUser(u)}>
//               View
//             </button>
//             <button
//               className="btn ban"
//               onClick={() => handleBanToggle(u.id)}
//             >
//               {u.status === "Active" ? "Ban" : "Unban"}
//             </button>
//             <button
//               className="btn delete"
//               onClick={() => handleDelete(u.id)}
//             >
//               Delete
//             </button>
//           </td>
//         </tr>
//       </CSSTransition>
//     ))}
//   </TransitionGroup>
// </tbody>

//       </table>

//       {/* User Modal */}
//       {selectedUser && (
//         <div className="user-modal">
//           <div className="user-modal-content">
//             <div className="modal-header">
//               <h3>{selectedUser.name}</h3>
//               <button onClick={() => setSelectedUser(null)}>✖</button>
//             </div>
//             <p><strong>Email:</strong> {selectedUser.email}</p>
//             <p><strong>Role:</strong> {selectedUser.role}</p>
//             <p><strong>Status:</strong> {selectedUser.status}</p>
//             <p><strong>Signup Date:</strong> {selectedUser.signupDate}</p>
//             <p><strong>Dispatches:</strong> 
//               {` ${selectedUser.dispatches.completed} completed, ${selectedUser.dispatches.pending} pending, ${selectedUser.dispatches.failed} failed`}
//             </p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Users;
import React, { useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import axios from "axios";
import "../styles/Users.css";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/admin/users`,
        {
          params: { search, status: filter, page, limit: 10 },
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        }
      );
      setUsers(res.data.users);
      setTotalPages(res.data.pages);
    } catch (err) {
      console.error("Failed to fetch users:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchUsers(); }, [search, filter, page]);

  const handleBanToggle = async (id, currentStatus) => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_API_BASE}/api/admin/users/${id}/ban`,
        {},
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      fetchUsers();
    } catch (err) {
      alert("Failed to update status.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure? This cannot be undone.")) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE}/api/admin/users/${id}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      fetchUsers();
    } catch (err) {
      alert("Failed to delete user.");
    }
  };

  return (
    <div className="users-section">
      <h2>Manage Users</h2>
      <div className="users-controls">
        <input
          type="text"
          placeholder="🔍 Search users..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="All">All</option>
          <option value="Active">Active</option>
          <option value="Banned">Banned</option>
        </select>
      </div>

      {loading ? <p>Loading...</p> : (
        <table className="users-table">
          <thead>
            <tr>
              <th>Name</th><th>Email</th><th>Role</th>
              <th>Status</th><th>Signup</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <TransitionGroup component={null}>
              {users.map((u) => (
                <CSSTransition key={u._id} timeout={300} classNames="fade-row">
                  <tr>
                    <td>{u.name}</td>
                    <td>{u.email}</td>
                    <td><span className={`role-badge ${u.role.toLowerCase()}`}>{u.role}</span></td>
                    <td><span className={`status-badge ${u.status.toLowerCase()}`}>{u.status}</span></td>
                    <td>{new Date(u.createdAt).toLocaleDateString()}</td>
                    <td>
                      <button className="btn ban" onClick={() => handleBanToggle(u._id, u.status)}>
                        {u.status === "Active" ? "Ban" : "Unban"}
                      </button>
                      <button className="btn delete" onClick={() => handleDelete(u._id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                </CSSTransition>
              ))}
            </TransitionGroup>
          </tbody>
        </table>
      )}

      {/* Pagination */}
      <div className="pagination">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={page === i + 1 ? "active" : ""}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Users;